export default "__VITE_ASSET__9l4orNL5__"